import React from "react"
import styled from "styled-components"
import { Flex, Icon } from ".."
import { colors } from "../.."

const BackToTop: React.FC = () => {
	const StyledBtn = styled.a`
		display: flex;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: ${colors.white};
		box-shadow: 0px 0px 16px 0px #33333333;
		border: solid 1px ${colors.blue66};

		&:hover {
			border: solid 1px ${colors.hoverBlue};
		}
	`
	return (
		<Flex position="fixed" bottom="24px" right={{ _: "16px", xl: "40px" }}>
			<StyledBtn href="#main">
				<Flex m="auto">
					<Icon icon="arrow-up" size={4}></Icon>
				</Flex>
			</StyledBtn>
		</Flex>
	)
}

export { BackToTop }
